import { CircleX, Info } from 'lucide-react';
import Icon from '@/components/primitives/Icon.jsx';

/** A short line in the conversation that is neither request nor reply: an answered approval, an error. */
const NoticeLine = ({ tone, text }) => {
  return (
    <p className="assistant-notice" data-tone={tone}>
      <Icon icon={tone === 'danger' ? CircleX : Info} size="sm" />
      <span>{text}</span>
    </p>
  );
};

export default NoticeLine;
